import { SET_UTM_PARAMS, CLEAR_UTM_PARAMS } from './mutation-types';
import { extractFromQuery, saveToStorage, loadFromStorage, clearFromStorage } from '@/utils/utm';

export async function ActionCaptureUtms({ commit }, query) {
  const params = extractFromQuery(query);
  if (params) {
    commit(SET_UTM_PARAMS, params);
    saveToStorage(params);
  }
}

export async function ActionLoadUtmsFromStorage({ commit, state }) {
  if (state.params) return;
  const params = loadFromStorage();
  if (params) {
    commit(SET_UTM_PARAMS, params);
  }
}

export async function ActionClearUtms({ commit }) {
  commit(CLEAR_UTM_PARAMS);
  clearFromStorage();
}
